import { Type, type Static } from "@sinclair/typebox";
import { LatLng } from "./domain.ts";

/** Centrifugo RPC `driver.location` — sent by the driver app over its WebSocket (ADR 0003). */
export const DriverLocationPing = Type.Object(
  {
    location: LatLng,
    heading: Type.Optional(Type.Number({ minimum: 0, maximum: 360 })),
    speedMps: Type.Optional(Type.Number({ minimum: 0 })),
    accuracyMeters: Type.Optional(Type.Number({ minimum: 0 })),
    recordedAt: Type.String({ format: "date-time" }),
  },
  { $id: "DriverLocationPing" },
);
export type DriverLocationPing = Static<typeof DriverLocationPing>;

export const RPC_METHODS = { driverLocation: "driver.location" } as const;
